/* eslint-disable no-nested-ternary */
import React, { useCallback, useEffect, useMemo, useState } from "react";

import Tooltip from "@mui/material/Tooltip";
import { colors } from "@zapalacorp/tokens";
import LayoutWaiting from "Components/Dialogs/LayoutWaiting/LayoutWaiting";
import { renderMilestoneDateByTypeAndReference } from "Components/Generic/MilestoneDates";
import MoreOptionOrderComponent from "Components/MoreOptionOrderComponent/MoreOptionOrderComponent";
import UtilizationComponent from "Components/UtilizationComponent/UtilizationComponent";
import { formatInTimeZone } from "date-fns-tz";
import { MilestoneReference, MilestoneType } from "Models/milestone";
import { Shipment } from "Models/shipments";
import { useTranslation } from "react-i18next";
import { calculateAndConvertOrdersVolume } from "Util/calculateAndConvertOrdersVolume";
import { calculateAndConvertTotalVolume } from "Util/calculateAndConvertTotalVolume";
import { calculateUtilization } from "Util/calculateUtilization";
import { getResourceByNameGroup } from "Util/getResourceByNameGroup";
import { useAppState } from "../../../../../../context/StateContext";
import { Job } from "../../../../../../models/job";
import {
  ShipmentTracking,
  ShipmentTrackingToExport,
} from "../../../../../../models/shipment.tracking";
import { Waybill } from "../../../../../../models/waybill";
import { calculateRawDelayedDaysWithoutTime } from "Util/calculateDelayedDays";
import {
  Mode,
  ResourceGroup,
  ResourceSubGroup,
  ShipmentStatus,
  ShipmentTrackingStatus,
  ShipmentType,
  Status,
} from "../../../../../../util/enums";
import { exportCSV } from "../../../../../../util/exportCsv";
import { getMeasurement } from "../../../../../../util/getMeasurement";
import { shipmentStatus } from "../../../../../../util/shipmentStatus";
import { INITIAL_PAGESIZE, useActions } from "../../hooks/useAction";
import { DataToShareLink } from "../../types";
import Buttons from "../Buttons";
import useStyles, { GridWrapper, DelayedDays } from "./styled";
import { checkResourceCan, FN_NAMES, hasPermission, isShowAction } from "Util/permissions";
import { ResourceCanEnum, ResourceName } from "Util/enums/accessRule";
import { isMoving } from "Util/validation";
import ModalPreferenceComponent from "../ModalPreferenceComponent/ModalPreferenceComponent";
import SelectStatusShipment from "../SelectStatusShipiment/SelectStatusShipiment";
import SelectTypeShipment from "../SelectTypeShipment/SelectTypeShipment";

import "../../style/style.scss";
import "./style.scss";
import BadgeShipmentTrackingStatusComponent from "Components/Generic/BadgeShipmentTrackingStatusComponent/BadgeShipmentTrackingStatusComponent";
import { GLOBAL_STATE_SHIPMENT, MAPPING_IMAGE_SHIPMENT_TYPE } from "../../constants/Waybills.const";
import ShipeeziGrid, {
  Column,
  ColumnFilter,
  GeneralActions,
  RowActionsExtra,
  SearchSuggest,
} from "Components/AppGrid/shipeezi-new-grid";
import { Button } from "Components/Form";
import { Color } from "Components/Form/Button";
import { useQuery } from "@tanstack/react-query";
import ModeJobService from "Services/mode.job.service";
import { NotificationToast } from "Components/Generic/Toast/NotificationToast";
import { onSearch } from "Util/onSearch";
import { EmptyContainer } from "../../../../../../modules/moving/components/Diary/views/DiaryResourcesView/subcomponent/ResourceList/styles";
import { EmptyTitle } from "../../../Operations/Maintenance/Waybill/styled";
import { format, isValid, parse } from "date-fns";
// eslint-disable-next-line import/order
enum DelayText {
  YES = "YES",
  NO = "NO",
}

interface WaybillGridProps {
  onOpenViewComponent: (id: number) => void;
  onConfirmationModal: (waybill?: Waybill) => void;
  onShareLink: (data: DataToShareLink) => void;
  wasDeletingSuccessfully?: boolean;
}

export default function WaybillGrid(props: WaybillGridProps) {
  const { currentUser, userPermissions } = useAppState();
  const { t: translate } = useTranslation();
  const [dataToExport, setDataToExport] = useState<ShipmentTrackingToExport[]>([]);
  const measurement = getMeasurement();
  const [shipmentPermission, setShipmentPermission] = useState<{
    view: {
      sea: boolean;
      air: boolean;
      road: boolean;
      rail: boolean;
    };
    create: {
      draft: boolean;
      publish: boolean;
    };
    edit: boolean;
    delete: boolean;
    printReport: boolean;
    communication: boolean;
  }>({
    view: {
      sea: false,
      air: false,
      road: false,
      rail: false,
    },
    create: {
      draft: false,
      publish: false,
    },
    edit: false,
    delete: false,
    printReport: false,
    communication: false,
  });

  const {
    waybills,
    page,
    pageSize,
    total,
    selectedStatus,
    selectedShipmentType,
    setSelectedShipmentType,
    selectedRowList,
    isOpenModalPreference,
    isOpenDialogExportCsv,
    onSubmitFormPreference,
    pageSizeList,
    setSelectedRowList,
    setIsOpenModalPreference,
    setPageSize,
    setIsOpenDialogExportCsv,
    handleCurrentPage,
    handleSearch,
    handleBillOfLanding,
    handleContainerId,
    handleSorting,
    columnFieldModalPreference,
    getWaybillList,
    getWaybillCount,
    getDataToExport,
    handleFilterTypeShipment,
    handleFilterStatusShipment,
    setColumnFieldSeaModalPreference,
    setColumnFieldAirModalPreference,
    searchInput,
    searchOptions,
    setSearchInput,
    setSearchOptions,
  } = useActions();

  const {
    setEditButton,
    setViewButton,
    // setDeleteButton,
    setSendEmailButton,
    setExportToCsvButton,
    setSelectAllRecord,
    setPreferences,
  } = Buttons();
  const { onOpenViewComponent, onConfirmationModal, onShareLink, wasDeletingSuccessfully } = props;
  const { refetch, isFetching } = getWaybillList();
  const { refetch: refetchCount } = getWaybillCount();
  const { refetch: refetchDataToExport, isFetching: fetchingDataToExport } = getDataToExport(
    (response: ShipmentTrackingToExport[]) => {
      setDataToExport(response);
      setIsOpenDialogExportCsv(false);
    }
  );

  const [shipmentTypes, setShipmentTypes] = useState<any[]>([]);
  const EMPTY_DOCUMENT = require("../../../../../../assets/img/empty-documents.png");

  const classes = useStyles();
  const getStyleForDelayText = (days?: number) => {
    if (days === undefined || days === null) return "";

    if (days > 0) {
      return DelayText.YES;
    }

    return DelayText.NO;
  };

  const shipmentPermissions = getResourceByNameGroup(
    ResourceGroup.OPERATIONS,
    ResourceSubGroup.OPERATIONS,
    ResourceName.SHIPMENTS,
    currentUser?.resources
  )?.roles_resources;

  const dateTimeFormat = useMemo(() => {
    const userDatePreference = currentUser?.preferences?.dateFormat;

    const preferredDateFormat = userDatePreference === "MM_DD_YYYY" ? "MM/dd/yyyy" : "dd/MM/yyyy";

    return `${preferredDateFormat}`;
  }, [currentUser?.preferences]);

  const formatDateWithUserPref = useCallback(
    (value: any) => {
      if (!value) return "";

      let date = new Date(value);

      if (!isValid(date)) {
        date = parse(value.toLowerCase(), "dd/MM/yyyy hh:mmaaa", new Date());
      }

      return isValid(date) ? format(date, dateTimeFormat) : value;
    },
    [dateTimeFormat]
  );

  const [columnSea, setColumnSea] = useState<Column[]>([
    {
      name: "containerId",
      title: `${translate("reference")}`,
      searchIdentifier: "container_id",
      hideSort: true,
    },
    {
      name: "loadType",
      title: translate("loadType"),
      hideSearch: true,
    },

    {
      name: "billOfLanding",
      title: `${translate("bolBooking")} #`,
      hideSort: true,
    },
    {
      name: "jobs",
      title: `${translate("order")} #`,
      formatComponent: (value: Job[], params: any) => {
        let ordersRefs: any[] = [];
        if (value?.length) {
          value.forEach((job) => {
            ordersRefs.push(job.reference);
          });
        }

        if (params?.customersToShipment) {
          params?.customersToShipment.forEach((customer: any) => {
            ordersRefs.push(customer.order ?? "");
          });
        }

        return <MoreOptionOrderComponent options={ordersRefs} />;
      },
      hideSearch: true,
      hideSort: true,
    },
    {
      name: "pol",
      title: translate("pol"),
      formatComponent: (value: string, params: any) => {
        const shipmentTracking = params?.shipmentTracking as ShipmentTracking;
        return shipmentTracking?.originPort || "";
      },
      hideSearch: true,
      hideSort: true,
    },
    {
      name: "pod",
      title: translate("pod"),
      formatComponent: (value: string, params: any) => {
        const shipmentTracking = params?.shipmentTracking as ShipmentTracking;
        return shipmentTracking?.finalPort || "";
      },
      hideSearch: true,
      hideSort: true,
    },
    {
      name: "etd",
      title: translate("etd"),
      formatComponent: (value: string, params: any) => {
        const shipmentTracking = params?.shipmentTracking as ShipmentTracking;

        return (
          <div>
            {shipmentTracking?.originPortActualDeparture
              ? formatDateWithUserPref(shipmentTracking?.originPortActualDeparture)
              : ""}
          </div>
        );
      },
      hideSearch: true,
      hideSort: true,
    },
    {
      name: "eta",
      title: translate("eta"),
      formatComponent: (value: string, params: any) => {
        const shipmentTracking = params?.shipmentTracking as ShipmentTracking;
        const etaDate = shipmentTracking?.finalPortPredictiveArrival;

        return <div>{etaDate ? formatDateWithUserPref(etaDate) : ""}</div>;
      },
      hideSearch: true,
      hideSort: true,
    },
    {
      name: "cargoReadyDate",
      title: translate("loadBy"),
      formatComponent: (value: string, params: any) => {
        if (!value) return "";
        return formatDateWithUserPref(value) || "";
      },
      hideSearch: true,
      hideSort: true,
    },
    {
      name: "delayed",
      title: translate("delayed"),
      formatComponent: (value: string, params: any) => {
        const shipmentTracking = params?.shipmentTracking as ShipmentTracking;

        const hasDelayData =
          shipmentTracking?.finalPortPredictiveArrival ||
          shipmentTracking?.finalPortPredictiveArrivalLast;

        return (
          <div>
            {hasDelayData
              ? onRenderCalculateDelayDays(
                  shipmentTracking?.finalPortPredictiveArrival,
                  shipmentTracking?.finalPortPredictiveArrivalLast
                )
              : ""}
          </div>
        );
      },
      hideSearch: true,
    },
    {
      name: "utilization",
      title: translate("utilization"),
      formatComponent: (value: string, params: any) => {
        const waybill = params as Waybill;
        const jobs = waybill.jobs as Job[];
        const calculateTotalVolumeContainer = calculateAndConvertTotalVolume(
          (waybill?.containers as any)?.map((item: any) => item.grossVolume)
        );
        const volumeAdd = calculateAndConvertOrdersVolume(getMeasurement(), jobs);
        const utilization = calculateUtilization(calculateTotalVolumeContainer, Number(volumeAdd));

        return <UtilizationComponent data={utilization} />;
      },
      hideSearch: true,
    },
    {
      name: "statusShipment",
      title: translate("status"),

      formatComponent: (value: string, params: any) => {
        const waybill = params as Waybill;

        return waybill?.shipmentTrackingId ? (
          <BadgeShipmentTrackingStatusComponent
            className={classes.badge}
            value={shipmentStatus(waybill.shipmentTracking?.shipmentStatus) ?? ""}
          />
        ) : (
          waybill?.statusShipment && (
            <BadgeShipmentTrackingStatusComponent
              className={classes.badge}
              value={waybill.statusShipment}
            />
          )
        );
      },
      hideSearch: true,
    },
  ]);

  const [columnAir, setColumnAir] = useState<Column[]>([
    {
      name: "containerId",
      title: `${translate("reference")}`,
      searchIdentifier: "container_id",
      hideSort: true,
    },
    {
      name: "loadType",
      title: translate("loadType"),
      hideSearch: true,
    },
    {
      name: "billOfLanding",
      title: `${translate("bolBooking")} #`,
    },
    {
      name: "jobs",
      title: `${translate("order")} #`,
      formatComponent: (value: Job[], params: any) => {
        let ordersRefs: any[] = [];
        if (value?.length) {
          value.forEach((job) => {
            ordersRefs.push(job.reference);
          });
        }

        if (params?.customersToShipment) {
          params?.customersToShipment.forEach((customer: any) => {
            ordersRefs.push(customer.order ?? "");
          });
        }

        return <MoreOptionOrderComponent options={ordersRefs} />;
      },
      hideSearch: true,
      hideSort: true,
    },
    {
      name: "origin",
      title: translate("originAirport"),
      hideSort: true,
      hideSearch: true,
    },
    {
      name: "destination",
      title: translate("destinationAirport"),
      hideSort: true,
      hideSearch: true,
    },
    {
      name: "etd",
      title: translate("etd"),
      formatComponent: (value: string, params: any) => {
        const row = params?.row as Shipment;
        const milestones = row?.milestones || [];

        return (
          <div>
            {milestones.length > 0
              ? renderMilestoneDateByTypeAndReference(
                  milestones,
                  MilestoneType.ESTIMATED,
                  MilestoneReference.WAYBILL.ESTIMATED.TIME_DEPARTURE
                )
              : ""}
          </div>
        );
      },
      hideSearch: true,
      hideSort: true,
    },
    {
      name: "eta",
      title: translate("eta"),
      formatComponent: (value: string, params: any) => {
        const { row } = params; // Ensure `isFetching` is available
        const shipmentTracking = row?.shipmentTracking as ShipmentTracking;

        const etaDate = shipmentTracking?.finalPortPredictiveArrival;

        return <div>{etaDate ? formatInTimeZone(new Date(etaDate), "UTC", "dd/MM/yyyy") : ""}</div>;
      },
      hideSearch: true,
      hideSort: true,
    },

    {
      name: "cargoReadyDate",
      title: translate("loadBy"),
      formatComponent: (value: string, params: any) => {
        if (!value) return "";
        return formatInTimeZone(new Date(value), "UTC", "dd/MM/yyyy") || "";
      },
      hideSearch: true,
      hideSort: true,
    },
    {
      name: "delayed",
      title: translate("delayed"),
      formatComponent: (value: string, params: any) => {
        const shipmentTracking = params?.shipmentTracking as ShipmentTracking;

        const hasDelayData =
          shipmentTracking?.finalPortPredictiveArrival ||
          shipmentTracking?.finalPortPredictiveArrivalLast;

        return (
          <div>
            {hasDelayData
              ? onRenderCalculateDelayDays(
                  shipmentTracking?.finalPortPredictiveArrival,
                  shipmentTracking?.finalPortPredictiveArrivalLast
                )
              : ""}
          </div>
        );
      },
      hideSearch: true,
    },
    {
      name: "utilization",
      title: translate("utilization"),
      formatComponent: (value: string, params: any) => {
        const waybill = params as Waybill;
        const jobs = waybill.jobs as Job[];
        const calculateTotalVolumeContainer = calculateAndConvertTotalVolume(
          (waybill?.containers as any)?.map((item: any) => item.grossVolume)
        );
        const volumeAdd = calculateAndConvertOrdersVolume(getMeasurement(), jobs);
        const utilization = calculateUtilization(calculateTotalVolumeContainer, Number(volumeAdd));

        return <UtilizationComponent data={utilization} />;
      },
      hideSearch: true,
    },
    {
      name: "statusShipment",
      title: translate("status"),

      formatComponent: (value: string, params: any) => {
        const waybill = params as Waybill;

        return waybill?.shipmentTrackingId ? (
          <BadgeShipmentTrackingStatusComponent
            className={classes.badge}
            value={shipmentStatus(waybill.shipmentTracking?.shipmentStatus) ?? ""}
          />
        ) : (
          waybill?.statusShipment && (
            <BadgeShipmentTrackingStatusComponent
              className={classes.badge}
              value={waybill.statusShipment}
            />
          )
        );
      },
      hideSearch: true,
    },
  ]);

  const renderEditRowButton = (id: string | number, waybill: Waybill) => {
    return shipmentPermissions?.edit && setEditButton(waybill);
  };
  const renderViewRowButton = (id: string | number, waybill: Waybill) => {
    return (
      shipmentPermissions?.view &&
      setViewButton(waybill, () => onOpenViewComponent(waybill.id || 0))
    );
  };
  const renderCommunicationRowButton = (id: string | number, waybill: Waybill) => {
    return shipmentPermissions?.edit && renderCommunication(waybill);
  };

  const transformData = (data: any[]) => {
    return data.reduce(
      (acc: { [x: string]: any }, item: { code: string | number; isChecked: any }) => {
        acc[item.code] = item.isChecked;
        return acc;
      },
      {}
    );
  };

  const updateColumnDataPreference = (
    items: any[],
    dataGridShipment: { [x: string]: { isChecked: any } }
  ) => {
    return items?.map((item: any, index: string | number) => ({
      ...item,
      isChecked: dataGridShipment[index]?.isChecked,
    }));
  };

  const modalPreferenceSetters: any = {
    [ShipmentType.SEA]: setColumnFieldSeaModalPreference,
    [ShipmentType.AIR]: setColumnFieldAirModalPreference,
    [ShipmentType.ROAD]: null,
  };

  const dataGridShipment = useMemo(() => {
    const shipmentKey = GLOBAL_STATE_SHIPMENT[selectedShipmentType];
    return JSON.parse(localStorage.getItem(shipmentKey) ?? "[]");
  }, [selectedShipmentType, isOpenModalPreference]);

  const renderCommunication = (row: Waybill) => {
    if (
      row?.shipmentTrackingId &&
      row?.shipmentTracking &&
      row?.shipmentTracking?.shipmentStatus &&
      [
        ShipmentTrackingStatus.TRACKING_NOT_AVAILABLE.toLowerCase(),
        ShipmentTrackingStatus.WAITING_FOR_UPDATE.toLowerCase(),
      ].includes(row?.shipmentTracking?.shipmentStatus?.toLowerCase() || "")
    ) {
      return null;
    }

    return setSendEmailButton(row, (emails: any, phones: any) =>
      onShareLink({
        id: row?.id || 0,
        emails,
        phones,
        reference: row?.containerId
          ? `${translate("shipmentNumber")} ${row?.containerId || ""}`
          : `${translate("containerNumber")} ${row?.containerNumbers || ""}`,
      })
    );
  };

  const onRenderCalculateDelayDays = (
    predictiveDateOfArrival?: string,
    predictiveDateOfArrivalLast?: string
  ) => {
    if (!predictiveDateOfArrival || !predictiveDateOfArrivalLast) return;

    const delayedDays = calculateRawDelayedDaysWithoutTime(
      predictiveDateOfArrivalLast,
      predictiveDateOfArrival
    );

    return (
      <DelayedDays type={getStyleForDelayText(delayedDays)}>
        {delayedDays > 0 ? delayedDays : 0} {translate("day").toLowerCase()}
      </DelayedDays>
    );
  };

  const renderFilterStatus = () => {
    const statusList = [
      ...Object.values(ShipmentTrackingStatus).map((key) => ({
        value: key,
        label: key.charAt(0).toUpperCase() + key.slice(1),
      })),
      {
        value: ShipmentStatus.DRAFT,
        label: ShipmentStatus.DRAFT.charAt(0).toUpperCase() + ShipmentStatus.DRAFT.slice(1),
      },
    ];

    return (
      <SelectStatusShipment
        options={statusList}
        onFilter={handleFilterStatusShipment}
        initialValue={selectedStatus}
      />
    );
  };
  const renderSelectionTypeShipment = () => {
    return (
      <SelectTypeShipment
        shipmentTypes={shipmentTypes}
        onChangeFilter={handleFilterTypeShipment}
        value={selectedShipmentType}
      />
    );
  };

  const renderPreference = () => {
    return setPreferences(() => {
      setIsOpenModalPreference(true);
    });
  };
  const renderExportCSV = () => {
    return setExportToCsvButton(fetchingDataToExport, () => {
      refetchDataToExport();
      setIsOpenDialogExportCsv(true);
    });
  };
  const renderSelectRowAll = () => {
    const hasItemSelected = selectedRowList.length > 0;
    const onClickHandler = () => {
      const updatedSelection: number[] = hasItemSelected
        ? []
        : waybills?.map((item) => item?.id).filter((id): id is number => typeof id === "number") ||
          [];
      setSelectedRowList(updatedSelection);
    };

    return (
      <Tooltip title={translate(hasItemSelected ? "unselectAll" : "selectAll")} placement="top">
        <Button customColor={Color.TEXT_INFO_BLUE} onClick={onClickHandler}>
          <span
            style={{
              color: colors.brandBlue500,
              fontSize: "12px",
              fontWeight: 600,
              lineHeight: "16px",
              fontStyle: "normal",
            }}
          >
            {translate(hasItemSelected ? "unselectAll" : "selectAll")}
          </span>
        </Button>
      </Tooltip>
    );
  };

  const onChangeSearchOptions = (options: ColumnFilter[]) => {
    let billOfLandingAttr;
    let containerId;
    setSearchOptions(options);
    const attributes = onSearch(options);
    const search = attributes?.map((item) => {
      if (item.attribute === "billOfLanding") {
        billOfLandingAttr = item?.values?.[0];
      }

      if (item.attribute === "container_id") {
        containerId = item?.values?.[0];
      }

      return {
        [item.attribute]: item?.values?.[0],
      };
    });

    handleBillOfLanding(billOfLandingAttr ?? "");
    handleContainerId(containerId ?? "");
    if (!billOfLandingAttr && !containerId) handleSearch(search);
  };

  const renderSearchSuggest = () => {
    return (
      <SearchSuggest
        columns={[
          { name: "container_id", title: `${translate("reference")}` },
          { name: "billOfLanding", title: `${translate("bolBooking")}#` },
        ]}
        columnsSelected={searchOptions}
        onChangeColumnsSelected={onChangeSearchOptions}
        inputValue={searchInput}
        onChangeInput={(value) => {
          setSearchInput(value);
        }}
        placeholder="Search"
      />
    );
  };

  const generalActions: GeneralActions = {
    orderBy: {
      left: [
        "renderTypeShipment",
        "renderSearchSuggest",
        "renderFilerStatus",
        "renderSelectRowAll",
      ],
      right: ["renderPreference", "renderExport"],
    },
    renderTypeShipment: renderSelectionTypeShipment(),
    renderFilerStatus: renderFilterStatus(),
    renderSelectRowAll: renderSelectRowAll(),
    renderPreference: renderPreference(),
    renderExport: isShowAction(currentUser, shipmentPermission?.printReport)
      ? renderExportCSV()
      : undefined,
    renderSearchSuggest: renderSearchSuggest(),
  };

  const onChangeVisibleColumns = (columns: any[]) => {
    if (selectedShipmentType === ShipmentType.SEA) {
      changeVisibleSeaColumns(columns);
    } else if (selectedShipmentType === ShipmentType.AIR) {
      changeVisibleAirColumns(columns);
    }
  };

  const changeVisibleSeaColumns = (columns: any[]) => {
    const columnsSeaToShow: string[] = columns
      ? columns.filter((item: any) => item.isChecked === true).map((item: any) => item.code)
      : [];
    const cloneColumnsSea = [...columnSea];
    for (let i = 0; i < cloneColumnsSea.length; i++) {
      const find = columnsSeaToShow?.find((item: any) => item === cloneColumnsSea[i].name);
      if (!find) {
        cloneColumnsSea[i].initialHideColumn = true;
      } else {
        cloneColumnsSea[i].initialHideColumn = false;
      }
    }
    setColumnSea(cloneColumnsSea);
  };

  const changeVisibleAirColumns = (columns: any[]) => {
    const columnsAirToShow: string[] = columns
      ? columns.filter((item: any) => item.isChecked === true).map((item: any) => item.code)
      : [];
    const cloneColumnsAir = [...columnAir];
    for (let i = 0; i < cloneColumnsAir.length; i++) {
      const find = columnsAirToShow?.find((item: any) => item === cloneColumnsAir[i].name);
      if (!find) {
        cloneColumnsAir[i].initialHideColumn = true;
      } else {
        cloneColumnsAir[i].initialHideColumn = false;
      }
    }
    setColumnAir(cloneColumnsAir);
  };

  useQuery(
    ["jobMode.list", currentUser?.companyId],
    () =>
      ModeJobService.getAll({
        status: Status.ACTIVE,
        companyId: currentUser?.companyId,
      }),
    {
      enabled:
        isShowAction(currentUser, shipmentPermission.view.air) ||
        isShowAction(currentUser, shipmentPermission.view.sea),
      onSuccess: (response: any) => {
        if (response && response?.data && response?.data?.length > 0) {
          const filterValues = ["Sea", "Air"];
          if (!isShowAction(currentUser, shipmentPermission.view.air)) {
            filterValues.splice(filterValues.indexOf("Air"), 1);
          }

          if (!isShowAction(currentUser, shipmentPermission.view.sea)) {
            filterValues.splice(filterValues.indexOf("Sea"), 1);
          }

          const filteredData = response.data
            .filter((item: any) => filterValues.includes(item.value))
            .sort((a: any, b: any) => {
              return filterValues.indexOf(a.value) - filterValues.indexOf(b.value);
            })
            .map((res: any) => ({
              ...res,
              image: MAPPING_IMAGE_SHIPMENT_TYPE[res?.value],
            }));

          setShipmentTypes(filteredData);
        }
      },
    }
  );

  useEffect(() => {
    if (userPermissions && userPermissions?.length > 0) {
      setShipmentPermission({
        view: {
          sea: hasPermission(userPermissions, FN_NAMES.FUNCTION_OPERATIONS_SHIPMENTS_VIEW_SEA),
          air: hasPermission(userPermissions, FN_NAMES.FUNCTION_OPERATIONS_SHIPMENTS_VIEW_AIR),
          road: hasPermission(userPermissions, FN_NAMES.FUNCTION_OPERATIONS_SHIPMENTS_VIEW_ROAD),
          rail: hasPermission(userPermissions, FN_NAMES.FUNCTION_OPERATIONS_SHIPMENTS_VIEW_RAIL),
        },
        create: {
          draft:
            checkResourceCan(userPermissions, ResourceName.SHIPMENTS, ResourceCanEnum.EDIT) &&
            hasPermission(userPermissions, FN_NAMES.FUNCTION_OPERATIONS_SHIPMENTS_DRAFT),
          publish:
            checkResourceCan(userPermissions, ResourceName.SHIPMENTS, ResourceCanEnum.EDIT) &&
            hasPermission(userPermissions, FN_NAMES.FUNCTION_OPERATIONS_SHIPMENTS_PUBLISH),
        },
        edit:
          checkResourceCan(userPermissions, ResourceName.SHIPMENTS, ResourceCanEnum.EDIT) &&
          hasPermission(userPermissions, FN_NAMES.FUNCTION_OPERATIONS_SHIPMENTS_EDIT),
        delete:
          checkResourceCan(userPermissions, ResourceName.SHIPMENTS, ResourceCanEnum.EDIT) &&
          hasPermission(userPermissions, FN_NAMES.FUNCTION_OPERATIONS_SHIPMENTS_DELETE),
        printReport: hasPermission(
          userPermissions,
          FN_NAMES.FUNCTION_OPERATIONS_SHIPMENTS_PRINT_REPORT
        ),
        communication:
          checkResourceCan(userPermissions, ResourceName.SHIPMENTS, ResourceCanEnum.EDIT) &&
          hasPermission(userPermissions, FN_NAMES.FUNCTION_OPERATIONS_SHIPMENTS_COMMUNICATION),
      });
    }
  }, [userPermissions]);

  useEffect(() => {
    if (dataToExport && dataToExport.length) {
      exportCSV(dataToExport, measurement, currentUser?.company?.name, () => setDataToExport([]));
    }
  }, [dataToExport]);

  useEffect(() => {
    if (wasDeletingSuccessfully) {
      refetch();
      refetchCount();
      onConfirmationModal();
    }
  }, [wasDeletingSuccessfully]);

  const changePage = (page: number) => {
    handleCurrentPage(page);
  };

  useEffect(() => {
    if (!shipmentTypes) return;
    const newShipmentTypes = shipmentTypes?.filter((shipmentType) => {
      if (
        (shipmentType?.value?.toLowerCase() === "sea" && shipmentPermission?.view?.sea) ||
        (shipmentType?.value?.toLowerCase() === "air" && shipmentPermission?.view?.air) ||
        (shipmentType?.value?.toLowerCase() === "road" && shipmentPermission?.view?.road) ||
        (shipmentType?.value?.toLowerCase() === "rail" && shipmentPermission?.view?.rail)
      )
        return shipmentType;
    });

    if (newShipmentTypes?.length > 0 && newShipmentTypes[0]?.value) {
      setSelectedShipmentType(newShipmentTypes[0]?.value);
    }
  }, [shipmentTypes, shipmentPermission]);

  useEffect(() => {
    if (!dataGridShipment || dataGridShipment.length <= 0) return;

    const newData = updateColumnDataPreference(
      columnFieldModalPreference?.[selectedShipmentType],
      dataGridShipment
    );
    const transformedData = transformData(dataGridShipment);

    if (isOpenModalPreference) {
      const setModalPreference = modalPreferenceSetters[selectedShipmentType];

      if (setModalPreference) {
        setModalPreference(newData);
      }
    }
  }, [selectedShipmentType, isOpenModalPreference]);

  useEffect(() => {
    const savedColumnsSea = window.localStorage.getItem(GLOBAL_STATE_SHIPMENT[Mode.Sea]) as any;
    if (savedColumnsSea) {
      const parsedColumnsSea = JSON.parse(savedColumnsSea);
      changeVisibleSeaColumns(parsedColumnsSea);
    }
    const savedColumnsAir = window.localStorage.getItem(GLOBAL_STATE_SHIPMENT[Mode.Air]) as any;
    if (savedColumnsAir) {
      const parsedColumnsAir = JSON.parse(savedColumnsAir);
      changeVisibleAirColumns(parsedColumnsAir);
    }
  }, []);

  const handleRowActionsExtraByPermission = () => {
    let rowActionsExtra: RowActionsExtra[] = [
      {
        title: translate("view"),
        key: "view",
        buttonAndAction: renderViewRowButton,
      },
    ];

    if (isShowAction(currentUser, shipmentPermission.edit)) {
      rowActionsExtra?.unshift({
        title: translate("edit"),
        key: "edit",
        buttonAndAction: renderEditRowButton,
      });
    }

    // if (isShowAction(currentUser, shipmentPermission.delete)) {
    //   rowActionsExtra?.push({
    //     title: translate("delete"),
    //     key: "delete",
    //     buttonAndAction: (_, row) => {
    //       if (!isMoving(currentUser?.company) && !shipmentPermissions?.edit) return null;

    //       return setDeleteButton(row, () => onConfirmationModal(row));
    //     },
    //   },)
    // }

    if (isShowAction(currentUser, shipmentPermission.communication)) {
      rowActionsExtra?.push({
        title: translate("communication"),
        key: "communication",
        buttonAndAction: renderCommunicationRowButton,
      });
    }

    return rowActionsExtra;
  };

  return (
    <div
      style={{
        padding: "32px 24px",
      }}
    >
      {!isShowAction(currentUser, shipmentPermission.view.sea) &&
        !isShowAction(currentUser, shipmentPermission.view.air) && (
          <div
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              flexDirection: "column",
            }}
          >
            <EmptyContainer>
              <img src={EMPTY_DOCUMENT} alt="empty document" />
              <EmptyTitle>{translate("youDontHavePermissionToAccessShipmentData")}</EmptyTitle>
            </EmptyContainer>
          </div>
        )}
      {isShowAction(currentUser, shipmentPermission.view.sea) &&
        selectedShipmentType === ShipmentType.SEA && (
          <div key={`${JSON.stringify(columnSea)}-${JSON.stringify(selectedRowList)}`}>
            <ShipeeziGrid
              columns={columnSea}
              data={waybills || []}
              totalItems={total}
              loadingData={isFetching}
              namePage={translate("shipments")}
              emptyData={
                isFetching
                  ? `${translate("loadingOrders")}...`
                  : translate("noInformationToBeShown")
              }
              pageSize={pageSize}
              pageSizeList={pageSizeList}
              onChangePageSize={(pageSize: number) => {
                setPageSize(pageSize);
                handleCurrentPage(1);
                setSelectedRowList([]);
              }}
              currentPage={page}
              onNextPage={handleCurrentPage}
              onPreviousPage={handleCurrentPage}
              onGoToPage={handleCurrentPage}
              selecteds={selectedRowList}
              handleSelect={(row: any) => {
                setSelectedRowList(row);
              }}
              onSorting={handleSorting}
              positionActionsColumn="right"
              generalActions={generalActions}
              showColumnChooser={false}
              stickyActions
              rowActionsExtra={[
                {
                  title: translate("edit"),
                  key: "edit",
                  buttonAndAction: renderEditRowButton,
                },
                {
                  title: translate("view"),
                  key: "view",
                  buttonAndAction: renderViewRowButton,
                },
                {
                  title: translate("communication"),
                  key: "communication",
                  buttonAndAction: renderCommunicationRowButton,
                },
              ]}
            />
          </div>
        )}

      {isShowAction(currentUser, shipmentPermission.view.air) &&
        selectedShipmentType === ShipmentType.AIR && (
          <div key={`${JSON.stringify(columnAir)}-${JSON.stringify(selectedRowList)}`}>
            <ShipeeziGrid
              columns={columnAir}
              data={waybills || []}
              totalItems={total}
              loadingData={isFetching}
              namePage={translate("shipments")}
              emptyData={
                isFetching
                  ? `${translate("loadingOrders")}...`
                  : translate("noInformationToBeShown")
              }
              pageSize={pageSize}
              pageSizeList={pageSizeList}
              onChangePageSize={(pageSize: number) => {
                setPageSize(pageSize);
                handleCurrentPage(1);
                setSelectedRowList([]);
              }}
              currentPage={page}
              onNextPage={handleCurrentPage}
              onPreviousPage={handleCurrentPage}
              onGoToPage={handleCurrentPage}
              selecteds={selectedRowList}
              handleSelect={(row: any) => {
                setSelectedRowList(row);
              }}
              onSorting={handleSorting}
              positionActionsColumn="right"
              generalActions={generalActions}
              showColumnChooser={false}
              rowActionsExtra={[
                {
                  title: translate("edit"),
                  key: "edit",
                  buttonAndAction: renderEditRowButton,
                },
                {
                  title: translate("view"),
                  key: "view",
                  buttonAndAction: renderViewRowButton,
                },
                {
                  title: translate("communication"),
                  key: "communication",
                  buttonAndAction: renderCommunicationRowButton,
                },
              ]}
            />
          </div>
        )}
      {isOpenModalPreference && (
        <ModalPreferenceComponent
          pageSize={pageSize}
          columnList={columnFieldModalPreference?.[selectedShipmentType] ?? []}
          label={translate("preferences")}
          isOpen={isOpenModalPreference}
          onClose={() => {
            setIsOpenModalPreference(false);
          }}
          onSubmit={(dataModal: any) => {
            onChangeVisibleColumns(dataModal?.newDataColumn);
            onSubmitFormPreference(dataModal);
            NotificationToast.success(translate("updatedPreference"));
          }}
        />
      )}
      {isOpenDialogExportCsv && (
        <LayoutWaiting
          sx={{
            "& .MuiPaper-root": {
              backgroundColor: colors.gray400,
              opacity: "0.4",
            },
          }}
          label={translate("exportingCSV")}
          isOpen={isOpenDialogExportCsv}
          onClose={() => setIsOpenDialogExportCsv(false)}
        />
      )}
    </div>
  );
}
